import React, {useState, useEffect} from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { blueIcon, redIcon, goldIcon, greenIcon, liveIcon} from "../icons/LeafletIcons.js";
import LocationForm from "./locationForm.js";
import EventForm from "./eventForm.js";
import EventPinSelector from "./eventPinSelector.js";
import useLiveLocation from "../hooks/useLiveLocation";
import CheckInButton from "./checkInButton";
import SignupForm from "./signUp.js";
import ShowEvents from "./showEvents.js";
import "../css/addLocation.css";
// import "../css/addEvent.css";
// import "../css/eventsList.css";
// import "../css/mapPage.css";
// import "../css/GCPillButton.css";
import "../css/profileForm.css";
import LoginForm from "./login.js";
import ProfileForm from "./profile.js";
import CentreMapOnUser from "./centreMaponUser.js";
import RecentreMapOnPins from "./recentreMaponPins.js";
import OtherProfileForm from "./otherProfile.js";
import AdminForm from "./Admin.js";
import ShowLocations from "./showLocations.js";
import StaticForm from "./Static.js";
import IndividualEventCard from "./individualEventCard.js";
import { useLanguage } from '../components/Language.js';
import { useRef } from "react";
import {BASE_URL} from "../constants"

//navigation bar
import person from "../assets/person-circle.svg";

import goldMember from "../assets/gold-status.svg";
import goldGaelic from "../assets/gold-gaelic.svg";
import silverMember from "../assets/silver-status.svg";
import silverGaelic from "../assets/silver-gaelic.svg";
import bronzeMember from "../assets/bronze-status.svg";
import bronzeGaelic from "../assets/bronze-gaelic.svg";
import firstSteps from "../assets/first-steps-english.svg";
import firstStepsGaelic from "../assets/first-steps-gaelic.svg";

import headerEnglish from "../assets/header-english.svg"
import headerGaelic from "../assets/header-gaelic.svg"


//footer
import eventButton from "../assets/event-button.svg";
import eventButtonSelected from "../assets/event-button-selected.svg";
import locationButton from "../assets/location-button.svg";
import locationButtonSelected from "../assets/location-button-selected.svg";
import plus from "../assets/plus.svg";
import learningButton from "../assets/learning-resources.svg";
import learningButtonSelected from "../assets/learning-resources-selected.svg";
import englishToggle from "../assets/translation-english.svg";
import gaelicToggle from "../assets/translation-gaelic.svg";


function MapComponent(){
  const { language, toggleLanguage } = useLanguage();
  const [locations, setLocations] = useState([]);
  const [events, setEvents] = useState([]);
  const [nearestEvents, setNearestEvents] = useState([]);
  const pos = [55.8591,-4.2581];
  const [isSignupVisible, setSignupVisible] = useState(false);
  const [isEventFormVisible, setEventFormVisible] = useState(false);
  const [isEventPinSelectorVisible, setEventPinSelectorVisible] = useState(false);
  const [isLocationFormVisible, setLocationFormVisible] = useState(false);
  const [isLoginVisible, setLoginVisible] = useState(false);
  const [isProfileVisible, setProfileVisible] = useState(false);
  const [isEventsVisible, setEventsVisible] = useState(false);
  const [isAdminVisible, setAdminVisible] = useState(false);
  const [username, setUsername] = useState(null);
  const [isLocationsVisible, setIsLocationsVisible] = useState(false);
  const [isStaticVisible, setIsStaticVisible] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);


  const [otherProfileData, setOtherProfileData] = useState(null);
  const [IsOtherProfile, setIsOtherProfile] = useState(false);

  const [eventPosition, setEventPosition] = useState([0,0]);
  const [eventClickActive, setEventClickActive] = useState(false);
  const [eventImageFile, setEventImageFile] = useState(null);
  const [eventFormData, setEventFormData] = useState({});

  const mapRef = useRef(null);

  const translations = {
    en: {
        findMe: "Find Me!",
        gaelicConnect: "Gaelic Connect",
        profile: "Profile",
        admin: "Admin",
        logOut: "Log Out",
        logIn: "Log In",
        signUp: "Sign Up",
        viewEvent: "View Event",
        currentLocation: "Your current location",
        addLocation: "Add Location",
        addEvent: "Add An Event",
        backEvents: "Back to all events view",
        checkIn: "Check In",
    },
    gd: {
        findMe: "Lorg mi!",
        gaelicConnect: "Ceangal Gàidhlig",
        profile: "Pròifil",
        admin: "Rianachd",
        logOut: "Log a-mach",
        logIn: "Log a-steach",
        signUp: "Clàraich",
        viewEvent: "Thoir sùil air an tachartas",
        currentLocation: "Your current location",
        addLocation: "Cuir ris àite",
        addEvent: "Cuir ris Tachartas",
        backEvents: "Air ais gu sealladh thachartasan uile",
        checkIn: "Clàir"
    },
};

  //let admin = JSON.parse(sessionStorage.getItem("USER"))["admin"]

  const [cookie, setCookie] = useState(() => {
    const localCookie = sessionStorage.getItem("COOKIE")
    if (localCookie === null) {
      return "";
    }else{
      return localCookie;
    }
  }) ;

  const handleGoToEvent = (eventId) => {
    console.log("Here at handleGoToEvent, Event_Id: ", eventId)
    setSelectedEventId(eventId);
    console.log("Selected event ID: ", selectedEventId);
  };

  const handleCloseEventCard = () => {
    setSelectedEventId(null);
  };


  // const [user, setUser] = useState({
  //   username: null,
  //   email: null,
  //   firstName: null,
  // });

  const [user, setUser] = useState(() => {
    const localUser = sessionStorage.getItem("USER")
    if (localUser === null){
      return {'firstName': '', 'username': '', 'email': ''}
      
    }else{
      return localUser;
    }
  });

  const centreMapOnUser = (lat, long) => {
    const map = mapRef.current;
    if (map) {
      map.flyTo([lat, long], 13);
    }
  };
  
  const recentreMapOnPins = (lat, long) => {
    const map = mapRef.current;
    if (map) {
      map.flyTo([lat, long], 13);
    }
  };

  const toggleSignup = () => {
    setSignupVisible(!isSignupVisible);
    setLoginVisible(false);
  };

  const toggleLogin = () => {
    setLoginVisible(!isLoginVisible);
    setSignupVisible(false);
  }

  const toggleStatic = () => {
    setIsStaticVisible(!isStaticVisible)
  }

  const handleLogin = (username, email, firstName, lastName, about, postcode, consent, gender, 
                      inital_lang, current_lang, tourist, profilePicture, ageRange, labels, admin, locations, level, cookie,) => {
    setUser(prevUser => ({
      ...prevUser,
      username: username,
      email: email,
      firstName: firstName,
      lastName: lastName,
      about: about,
      postcode: postcode,
      consent: consent,
      gender: gender,
      inital_lang: inital_lang,
      current_lang: current_lang,
      tourist: tourist,
      profilePicture: profilePicture,
      ageRange: ageRange,
      labels: labels,
      admin: admin,
      locations: locations,
      level: level,
    }));
    setUsername(username);
    setCookie(cookie);
    setLoginVisible(false);

    var session_user = {'firstName': firstName, 'username': username, 'email': email, 
      "lastName": lastName, "about": about, "postcode": postcode, "consent": consent,
    "gender": gender, "initalLang": inital_lang, "currentLang": current_lang, 
    "tourist": tourist,"profilePicture": profilePicture,
    "ageRange": ageRange, "labels": labels, "admin": admin, "locations": locations, "level": level,}
    sessionStorage.setItem("USER", JSON.stringify(session_user));
    sessionStorage.setItem("COOKIE", JSON.stringify(cookie));

  }

  const handleLogout = async () => {
    if (cookie === "") {
        console.error("No cookie available for logout");
        return;
    }

    setUsername(null);
    setCookie(null);
    setUser(null);
    sessionStorage.clear();

};

useEffect(() => {
  console.log("User state updated");
}, [user]); 

const handleAdmin = async () => {
  setAdminVisible(!isAdminVisible);
}

const handleProfile = async () => {
  //console.log(user.email);
  setProfileVisible(!isProfileVisible);
  }

const handleAddEvent = async () => {
    setEventFormVisible(!isEventFormVisible);
}

const handleAddLocation = async () => {
  setLocationFormVisible(!isLocationFormVisible);
}
const handleViewLocations = async () => {
  setIsLocationsVisible(!isLocationsVisible);
}

const handleViewEvents = async () => {
  setEventsVisible(!isEventsVisible);
}




  const fetchLocations = async () => {
    try{
      const response = await fetch(`${BASE_URL}/api/get_location_data/`);
      if (!response.ok){
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setLocations(data);
    } catch (error) {
      console.error('Error fetching location data:', error);
    }
  };

  const fetchEvents = async () => {
    try{
      const response = await fetch(`${BASE_URL}/api/events/`);
      if (!response.ok){
        throw new Error('Unable to receive successful network response');
      }
      const data = await response.json();
      console.log("Fetched data: ", data);
      setEvents(data);
    } catch (error) {
      console.error('Error fetching event data:', error);
    }
  };

 


  const fetchNearestEvents = async () => {
      try{
        const response = await fetch(
          `${BASE_URL}/api/nearest_events/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({ 
              latitude: parseFloat(liveLoc.lat),
              longitude: parseFloat(liveLoc.long),
            }),
          });

          const data = await response.json();
          setNearestEvents(data);

        } catch (error) {
          console.error('Error fetching event data:', error);
        }

};


useEffect(() => {
  
  fetchLocations();
  fetchEvents();
  //fetchNearestEvents();
  
}, []);


const refreshLocationAdded = () => {
  fetchLocations();
};

const liveLoc = useLiveLocation();

  async function performCheckinUpdate(event_id, username) { 

    console.log(event_id);
            
    let res = await fetch(`${BASE_URL}/api/update_checkins/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ event_id: event_id, username: username }),
    });

    let response = await res.json();
    alert(response.message);

  };

  async function performLikeUpdate(event_id, username) { 

    let res = await fetch(`${BASE_URL}/api/update_likes/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ event_id: event_id, username: username }),
    });

    let response = await res.json();
    alert(response.message);

  };

  async function performEventDetailUpdate(event_id, field, newValue) { 
    
    console.log("event id ", event_id );
    console.log("field ", field );
    console.log("new value ", newValue );

    const response = await fetch(`${BASE_URL}/api/update_event/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ event_id: event_id, field: field, newValue: newValue, set_confirm_title:false  }),
    });

    if (!response.ok){
      throw new Error('Unable to receive successful network response');
    }
    const data = await response.json();
    
    if (typeof data["error"] !== 'undefined'){
      console.log(data["error"]);

       if (window.confirm(data["error"] + "Do you want to continue?")){

          //user is fine to use existing title, return back to view and set title
          const response = await fetch(`${BASE_URL}/api/update_event/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ event_id: event_id, field: field, newValue: newValue, set_confirm_title:true }),
          });

          if (!response.ok){
            throw new Error('Unable to receive successful network response');
          }

        }else{
          //user does not want to use existing title
          return JSON.stringify({error: true })
        }
    }

    return JSON.stringify({error: false})

  };

  

  function checkIn() {

      //set check in button to be disabled
      let check_in_button = document.getElementById("map-check-in-button");
      check_in_button.disabled = true;

      let my_div = document.getElementById("checkin-confirm");

      //add blurred background effect after button is clicked and pop up shows
      const map_element = document.querySelector('.leaflet-tile-pane')
      map_element.style.opacity = 0.5;
      console.log(map_element);

      var para = document.createElement("p");
      para.style.color = "black";

      //button to close the pop up 
      var close_button = document.createElement("button");
      close_button.className = "pop-up-button"

      close_button.onclick = function() {
        map_element.style.opacity = 1;
        my_div.style.display = "none";
        my_div.innerHTML = '';
        check_in_button.disabled = false;
      }

      if (liveLoc.loadComplete){
        if (!liveLoc.error){

          console.log('loaded live location');
          console.log([liveLoc.lat]);

          //determine if user location is within a radius of events 
          let radius = 0.05;

          //use lat and long of user location as circle centre
          let a = liveLoc.lat;
          let b = liveLoc.long; 

          //for testing that multiple locations are nearby 
          // let radius = 0.5;
      
          //using university gardens location for testing event check in
          // let a = 55.873;
          // let b = -4.2901

          //using coffee morning location for testing event check in 
          // let a = 55.86116;
          // let b = -4.25388;

          //equation of a circle: (x - h)^2 + (y - k)^2 = r^2
          //distance d = sqrt( (x - h)^2 + (y - k)^2 )
          //if d <= r^2, the location is within a suitable distance to live location

          //find all locations that are within a circle with radius = r around the user's live location
          let possible_events = []; 

          for (let event in events){
            let x = events[event].latitude;
            let y = events[event].longitude;
            let distance = Math.sqrt( Math.pow((x - a), 2) + Math.pow((y - b), 2) )
            
            if (distance <= Math.pow(radius, 2)){
              possible_events.push(events[event]);
            }
          }

          let checkin_username = JSON.parse(sessionStorage.getItem("USER"))['username']

          if (possible_events.length === 0){
            
            //no nearby events to check in to
            var text = document.createTextNode("You don't seem to be near any events to check in. Please move closer or check in manually.");
            para.appendChild(text);
            my_div.appendChild(para)

            //ok button 
            var close_button_text = document.createTextNode("Okay");
            close_button.appendChild(close_button_text);
            my_div.appendChild(close_button);

            //display pop up
            my_div.style.display = "block";
            

          }else if (possible_events.length > 1){

            //multiple nearby events
            var text = document.createTextNode("There appear to be multiple events near you, please select the event you would like to check in to:");
            para.appendChild(text);
            my_div.appendChild(para)
            console.log(my_div);

            for (let event in possible_events){
              var button = document.createElement("button");
              var button_text = document.createTextNode(possible_events[event].title);
              button.appendChild(button_text);
              button.className = "pop-up-button"

              button.onclick = async (e) => {
                performCheckinUpdate(possible_events[event].id, checkin_username);
                refreshLocationAdded();
                map_element.style.opacity = 1;
                my_div.style.display = "none";
                my_div.innerHTML = '';
                check_in_button.disabled = false;
              };
              
              my_div.appendChild(button);
            }

            //none of these button 
            var close_button_text = document.createTextNode("I don't want to check into any of these events");
            close_button.appendChild(close_button_text);
            my_div.appendChild(close_button);

            //display pop up
            my_div.style.display = "block";

          }else{
            // only one nearby event
            let event_name = possible_events[0].title
            let event_id = possible_events[0].id

            var text = document.createTextNode("Would you like to check in to " + event_name + "?");
            para.appendChild(text);
            my_div.appendChild(para)

            //yes button 
            var yes_button = document.createElement("button");
            var yes_button_text = document.createTextNode("yes");
            yes_button.appendChild(yes_button_text);
            yes_button.className = "pop-up-button"

            yes_button.onclick = async (e) => {
                performCheckinUpdate(event_id, checkin_username);         
                refreshLocationAdded();
                map_element.style.opacity = 1;
                my_div.style.display = "none";
                my_div.innerHTML = '';
                check_in_button.disabled = false;
            };

            my_div.appendChild(yes_button);

            //no button 
            var close_button_text = document.createTextNode("no");
            close_button.appendChild(close_button_text);
            my_div.appendChild(close_button);

            //display pop up
            my_div.style.display = "block";

          }

        }else{

          //show loading message and request user tries again in a moment
          console.log([liveLoc.error]);
          var wait_text = document.createTextNode([liveLoc.error.errorMsg]);
          para.appendChild(wait_text);
          my_div.appendChild(para);

          var close_button_text = document.createTextNode("Okay");
          close_button.appendChild(close_button_text);
          my_div.appendChild(close_button);

          my_div.style.display = "block";
        }

      }else{

        console.log('please wait while your location loads');
        var wait_text = document.createTextNode("Please wait while your live location loads ... ");
        para.appendChild(wait_text);
        my_div.appendChild(para);

        var close_button_text = document.createTextNode("Okay");
        close_button.appendChild(close_button_text);
        my_div.appendChild(close_button);

        my_div.style.display = "block";
      }
  };


  const fetchProfileData = async (username) => {
    
      const response = await fetch(`${BASE_URL}/api/gather_profile_data/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();
      setOtherProfileData(data);
      setIsOtherProfile(!IsOtherProfile);
      console.log(IsOtherProfile);
  }
  

  const EventMarker = () => {
    
    const map = useMapEvents({click(e){
        setEventPosition([e.latlng.lat, e.latlng.lng]);
    }})

    return (
      eventPosition && eventClickActive ? (
        <Marker
          key = {eventPosition[0]}
          position = {eventPosition}
          icon = {blueIcon}
        >
          <Popup>({eventPosition[0]}, {eventPosition[1]})</Popup>
        </Marker>
      ):(
        null
      )
    )
  }


  const handleEventSave = async() => {

    const latitude = eventPosition[0];
    const longitude = eventPosition[1];
    const formData = eventFormData;
    const imageFile = eventImageFile;

    if (!isNaN(latitude) && !isNaN(longitude)) {

        let response = await fetch(`${BASE_URL}/api/save_event/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },

        body: JSON.stringify({ 
            event_title: formData.event_title, 
            description: formData.description, 
            start_time: formData.start_time,
            end_time: formData.end_time,
            start_date: formData.start_date,
            end_date: formData.end_date,
            postcode: formData.postcode,
            latitude: latitude,
            longitude: longitude,
            event_proficiency: formData.event_proficiency,
            event_type: formData.event_type,
            age_bracket: formData.age_bracket,
            language: formData.language, 
            host: JSON.parse(sessionStorage.getItem("USER"))
        }),

        });

        let data = await response.json(); 

        if (response.ok) {

            const event_id = data["event_id"];
            const imageData = new FormData();

            if (imageFile === null){
                imageData.append('picture', null);
            }else {
                imageData.append('picture', imageFile);
            }

            imageData.append('event_id', event_id);

            try {
                await fetch(`${BASE_URL}/api/save_event_picture/`, {
                    method: "POST",
                    body: imageData,
                });

            }catch (error) {
                console.error("Unable to upload event picture");
            }

        }
        
        setEventFormData({});
        setEventImageFile(null);
        fetchEvents();
        setEventPinSelectorVisible(false);
        setEventClickActive(false);
        alert(data.message);
    }
  }


  const retrieveLatLong = async(formData, imageFile) => {

    setEventFormData(formData);
    setEventImageFile(imageFile);
    setEventFormVisible(false);
    setEventPinSelectorVisible(true);
    setEventClickActive(true);

  }
  

  return (
    <div>
      

      <div style={{ height: '100%', width: '100%', position:'absolute', zIndex:1}}>
        {/* <header className = "map-header"> */}
        <nav class="navbar fixed-top bg-primary" id="map-header">
          <button id="header-name" className="btn btn-sm text-primary ms-1 mb-2" onClick={toggleLanguage}>
            {language === "en" ? 
              <img className="nav-img" src={englishToggle} alt="english" />
            :
              <img className="nav-img" src={gaelicToggle} alt="gaelic" />
            }
          </button>
          <button id="header-name-2" className="btn btn-sm text-primary mb-2">
            {language === "en" ? 
              <img className="nav-img" src={headerEnglish} alt="english" />
            :
              <img className="nav-img" src={headerGaelic} alt="gaelic" />
            }
          </button>

          <div className="profile-buttons">
            {JSON.parse(sessionStorage.getItem("USER"))?.username ? (
              <>

            <button className="btn btn-primary btn-sm rounded">
                <div className="dropdown">
                    <button className="btn btn-sm p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">

                        {JSON.parse(sessionStorage.getItem("USER")).level === "Gold" ? (
                          <>
                          {language === "en" ?
                            <img className="nav-img" src={goldMember} alt="gold member" />
                          :
                            <img className="nav-img" src={goldGaelic} alt="gold member" />
                          }
                          </>
                        ):(
                          <>
                          {JSON.parse(sessionStorage.getItem("USER")).level === "Silver" ? (
                            <>
                            {language === "en" ?
                              <img className="nav-img" src={silverMember} alt="silver member" />
                            :
                              <img className="nav-img" src={silverGaelic} alt="silver member" />
                            }
                            </>
                          ):(
                            <>
                            {JSON.parse(sessionStorage.getItem("USER")).level === "Bronze" ? (
                              <>
                              {language === "en" ?
                                <img className="nav-img" src={bronzeMember} alt="bronze member" />
                              :
                                <img className="nav-img" src={bronzeGaelic} alt="bronze member" />
                              }
                              </>
                            ):(
                              <>
                              {language === "en" ?
                                <img className="nav-img" src={firstSteps} alt="first steps" />
                              :
                                <img className="nav-img" src={firstStepsGaelic} alt="first steps gaelic" />
                              }
                              </>
                            )}
                            </>
                          )}
                          </>
                        )}

                    </button>
                    {/* <div className="justify-content-end"> */}
                      <ul className="dropdown-menu dropdown-menu-end justify-content-end">
                          <li><button className="dropdown-item" onClick={handleLogout}>{translations[language].logOut}</button></li>
                          <li><button className="dropdown-item" onClick={() => setProfileVisible(!isProfileVisible)}>{translations[language].profile}</button></li>
                          {JSON.parse(sessionStorage.getItem("USER"))?.admin && (
                            <li><button className="dropdown-item" onClick={handleAdmin}>{translations[language].admin}</button></li>
                          )}
                      </ul>
                    {/* </div> */}
                </div>
              </button>

              </>

            ) : (
              <>

              <button className="btn btn-sm mt-3 rounded">
                <div className="dropdown">
                    <button className="btn btn-sm p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <img className="nav-img" src={person} alt="account" />
                    </button>

                    <ul className="dropdown-menu dropdown-menu-end">
                        <li><button className="dropdown-item" onClick={toggleLogin}>{translations[language].logIn}</button></li>
                        <li><button className="dropdown-item" onClick={toggleSignup}>{translations[language].signUp}</button></li>
                    </ul>
                </div>
              </button>

              </>
            )}

          </div>
        </nav>
        {/* </header> */}

        <MapContainer center={pos} zoom={13} scrollWheelZoom={true} style={{ height: '100%', width: '100%' }} ref={mapRef}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />

          <EventMarker />
        
          {locations.map((location, index) => (
            <Marker
              key = {index}
              position = {[location.locationLatitude, location.locationLongitude]}
              icon = {(location.locationColour === "blue" && blueIcon) || 
                  (location.locationColour === "red" && redIcon) || 
                  (location.locationColour === "gold" && goldIcon) ||
                  (location.locationColour === "green" && greenIcon)}
            >
              <Popup>{location.locationName + ": "}{location.locationDescription}</Popup>
            </Marker>
          ))}


          {events.map((event, index) => (
            <Marker
              key = {index}
              position = {[event.latitude, event.longitude]}
              icon = {redIcon}
            >
              <Popup>
                <strong>{event.title}</strong>
                <br />
                {event.description}
                <br />
                <button className="btn btn-primary btn-sm my-2" onClick={() => handleGoToEvent(event.id)}>{translations[language].viewEvent}</button>
              </Popup>
            </Marker>
          ))}

          {liveLoc.loadComplete && !liveLoc.error && (
            <Marker
              position = {[liveLoc.lat, liveLoc.long]}
              icon = {liveIcon}
            >
              <Popup>{translations[language].currentLocation}</Popup>
            </Marker>
          )}
        
        </MapContainer>
      </div>

  <nav class="navbar fixed-bottom bg-primary" id="map-footer">
  {/* <footer className="map-footer"> */}
  <div className="d-flex justify-content-around w-100">
    {/* <div className="constant-buttons"> */}

      <img onClick={handleViewLocations} className="nav-img mt-1" src={isLocationsVisible ? locationButtonSelected : locationButton} alt="locations" />

      <img onClick={handleViewEvents} className="nav-img mt-1" src={isEventsVisible ? eventButtonSelected : eventButton} alt="nearest event" />

    {/* </div> */}

    {JSON.parse(sessionStorage.getItem("COOKIE")) !== undefined && (
      <div>
        <div id="checkin-confirm"></div>

        {JSON.parse(sessionStorage.getItem("USER"))?.username ? (
        <>

          <div className="btn-group dropup">
            <button type="button" className="btn btn-primary" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div className="plus-icon-container">
                <img src={plus} alt="add event" />
              </div>
            </button>
            <div className="dropdown-menu">
              <ul className="list-unstyled">
                <li><button className="dropdown-item" onClick={handleAddEvent}> {translations[language].addEvent}</button></li>

                {JSON.parse(sessionStorage.getItem("USER"))?.admin && (
                  <li><button className="dropdown-item" onClick={handleAddLocation}>{translations[language].addLocation}</button></li>
                )}

                <li><CheckInButton label={translations[language].checkIn} checkIn={checkIn}></CheckInButton></li>

                <li>
                  <button 
                    className="dropdown-item"
                    onClick={() => centreMapOnUser(liveLoc.lat, liveLoc.long)}
                    disabled={!liveLoc.loadComplete || liveLoc.error}
                  >
                    {translations[language].findMe}
                  </button>
                </li>
                
                <li><button className="dropdown-item" onClick={() => recentreMapOnPins(pos[0], pos[1])}>{translations[language].backEvents}</button></li>
                
              </ul>
            </div>
          </div>
        </>
        ):(
          <button onClick={() => alert("You need to sign in to add events")} type="button" className="btn btn-primary">
              <div className="plus-icon-container">
                <img src={plus} alt="add event" />
              </div>
            </button>
        )}

      </div>
    )}

  
    <img onClick={toggleStatic} className="nav-img mt-1" src={isStaticVisible ? learningButtonSelected : learningButton} alt="resources" />



  </div>
  {/* </footer> */}
  </nav>

      
    

    {isSignupVisible && (
      <div className="signup-form-container">
    
      {/* <div className="signup-form-container modal fade" id="exampleModalScrollable" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true"> */}
        <div className="modal-dialog modal-dialog-scrollable" role="document">
          <div className="modal-content">
            
            <div className="model-body">
              <SignupForm onClose = {() => setSignupVisible(false)} />
            </div>
          </div>
        </div>
      {/* </div> */}
      </div>
    )}


    {isLoginVisible && (
      <div className="login-form-container">
          <div className="modal-dialog modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="model-body">
                <LoginForm 
                  onLogin = {handleLogin} 
                  onClose= {() => setLoginVisible(false)} 
                />
              </div>
            </div>
          </div>
      </div>
    )}

    {isProfileVisible && (
    // <div className="profile-form-container active">
      <ProfileForm 
        user = {JSON.parse(sessionStorage.getItem("USER"))} 
        setUser={setUser}
        setCookie={setCookie}
        onClick = {handleProfile} 
        onClose= {() => setProfileVisible(false)}
      />
    // </div>
    )}

    {isAdminVisible && (
      <div className="profile-form-container active">
        <AdminForm
          user = {JSON.parse(sessionStorage.getItem("USER"))} 
          setUser={setUser}
          setCookie={setCookie}
          onClick = {handleAdmin} 
          onClose= {() => setAdminVisible(false)}
           />
      </div>
    )}

   {isEventFormVisible && (
      <div className="event-form-container active">
      <EventForm 
        events={events}
        user = {JSON.parse(sessionStorage.getItem("USER"))} 
        fetchEvents = {fetchEvents}
        retrieveLatLong = {retrieveLatLong}
        onClose= {() => setEventFormVisible(false)}
      />
      </div>
    )}

    {isEventPinSelectorVisible && (
        <EventPinSelector 
          handleEventSave={handleEventSave}
        />
    )}

    {selectedEventId && (
      
      <div className="events-container active">
        <IndividualEventCard
          eventId={selectedEventId}
          onClose={handleCloseEventCard}
        />
      </div>
    )}


    {isLocationFormVisible && (
      <div className="location-form-container active">
        <LocationForm
        fetchLocations = {fetchLocations}
        onClose = {() => setLocationFormVisible(false)}
        />
      </div>
    )}


   {isEventsVisible && (
    <div className="events-container active">
    <ShowEvents
      fetchNearestEvents={fetchNearestEvents}
      events = {nearestEvents}
      performCheckinUpdate = {performCheckinUpdate}
      performLikeUpdate = {performLikeUpdate}
      performEventDetailUpdate = {performEventDetailUpdate}
      onClose= {() => {setEventsVisible(false); fetchEvents();}}
      user = {JSON.parse(sessionStorage.getItem("USER"))} 
     />
    </div>
   )}

    {IsOtherProfile && (
      <div className="signup-form-container active">
        <OtherProfileForm
          otherProfileData={otherProfileData}
          onClose={() => setIsOtherProfile(false)}
        />
      </div>
      )}

    {isLocationsVisible && (
      <div className="events-container active">
      <ShowLocations
      onClose={() => setIsLocationsVisible(false)}
      />
      </div>
    )}



{isStaticVisible && (
  <div className="profile-form-container active">
    <StaticForm
      onClose={() => setIsStaticVisible(false)}
    />
  </div>
)}
  </div>
  
  );
}
  

export default MapComponent;
